import React, { useCallback } from "react";
import TrackedButton from "../TrackedButton";
import { useDropzone } from "react-dropzone";
import { Form } from "react-bootstrap";

const UntypedForm = Form as any;

type Props = {
  onDrop: (files: File[]) => any;
  btnText?: string;
};
export const DropzoneBtn: React.SFC<Props> = ({ onDrop, btnText }) => {
  const onDropFn = useCallback(onDrop, [onDrop]);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDropFn,
  });

  return (
    <div {...getRootProps()}>
      <UntypedForm.Control {...getInputProps()} />
      <TrackedButton className="mr-2" variant="link" action="addMoreFilesClick">
        {btnText}
      </TrackedButton>
    </div>
  );
};

DropzoneBtn.defaultProps = {
  btnText: "Add more documents",
};
export default DropzoneBtn;
